import { ReportStudioTemplateDrawOption } from '@/modules/ta/reportstudio/models/ReportStudioTemplateDrawOption';

export class ReportStudioTemplateMetadata {
  /**
   * @var {array[DrawOptions]}
   */
  draw_options;

  /**
   * @var {string}
   */
  font_size;

  /**
   * @var {array}
   */
  chart_palette;

  /**
   * @var {string}
   */
  created_from;

  /**
   * @var {string}
   */
  filter_mode;

  /**
   * @var {string}
   */
  font_type;

  /**
   * @var {boolean}
   */
  enable_demo_mode;

  /**
   * @var {boolean}
   */
  hide_empty_exported_widgets;

  constructor(model = {}) {
    this.draw_options = new ReportStudioTemplateDrawOption(model.draw_options);
    this.font_size = model.font_size;
    this.chart_palette = model.chart_palette;
    this.created_from = model.created_from;
    this.filter_mode = model.filter_mode;
    this.font_type = model.font_type;
    this.enable_demo_mode = model.enable_demo_mode;
    this.hide_empty_exported_widgets = model.hide_empty_exported_widgets;
  }
}
